import { Component, OnInit, Output, inject, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CampaignService } from '../campaign-service/campaign-service';
import { CampaignTemplate } from '../campaign-model/campaign-model';
import { HttpStatusCode } from 'axios';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { CampaignPayload } from '../create-campaign-model/create-campaign-model';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
interface droptdownload {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-create-campaign',
  providers: [provideNativeDateAdapter()],
  imports: [
    PiasLayoutComponent,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
    MatIcon,
    CommonModule,
    MatSelectModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatButtonToggleModule
  ],
  templateUrl: './create-campaign.component.html',
  styleUrl: './create-campaign.component.scss'
})
export class CreateCampaignComponent implements OnInit {
  @Output() next = new EventEmitter<boolean>();

  private fb = inject(FormBuilder);
  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private campaignService = inject(CampaignService);
  private snackBarService = inject(SnackbarService);
  public campaignForm!: FormGroup;
  public message = 'This field is required';
  csvFile: File | null = null;
  public selectedFileName: string = '';
  templates: droptdownload[] = [
    // {value: '5', viewValue: 'FAR -  Communication LD1   '},
    // {value: '6', viewValue: 'FSD -  Communication LD1  '},
    // {value: '7', viewValue: 'Vendor/Partner -  Communication LD1'},
    // {value: '1', viewValue: 'Client - Communication LD1  '},
    // {value: '8', viewValue: 'Fund Risk Classification Notification - Aug 2026  '}
  ];
  fileName = '';
  activeChannel: 'email' | 'whatsapp' = 'email';

  campaignTemplates: CampaignTemplate[] = [];
  campaignpayload: CampaignPayload[] = [];
  // Store the EXACT template we want to show on screen right now
  activeTemplate: CampaignTemplate | undefined;

  // Track which button is highlighted (defaults to email)
  // selectedChannel: 'email' | 'whatsapp' | null = null;
  selectedChannel: 'email' | 'whatsapp' | 'sms' | null = 'email';
  isLoading = true;
  ngOnInit(): void {
    this.initializeForm();
    //  Ask the service for the data
    // this.campaignService.viewcampaign({ id: 1, channel: 'email' }).then((cleanData) => {
    // //   this.campaignTemplates = cleanData;
    //   this.isLoading = false;

    // });
    this.loadTemplates('email');
  }
  switchChannel(channel: 'email' | 'whatsapp' | 'sms') {
    this.selectedChannel = channel; // Update the highlighted button
    this.campaignForm.get('template')?.reset('');   // added: old selection clear
    this.loadTemplates(channel);// added: API call on channel select


    if (channel === 'email') {
      // Show Email (Index 0 from your array)
      this.activeTemplate = this.campaignTemplates[0];
    } else if (channel === 'whatsapp') {
      // Show WhatsApp (Index 1 from your array)
      this.activeTemplate = this.campaignTemplates[1];
    }
  }

  private initializeForm(): void {
    this.campaignForm = this.fb.group({
      campaignName: ['', Validators.required],
      template: ['', Validators.required]
      // channel: ['', Validators.required],
      // template: ['', Validators.required],
      // contactList: ['', Validators.required],
      // scheduleTime: ['', Validators.required]
    });
  }


  // fetchAndLogCampaigns() {
  //   this.campaignService.viewcampaign()
  //     .then((response) => {
  //       // 3. Log the successful response to the console
  //       console.log(' API Response:', response);
  //     })
  //     .catch((error) => {
  //       // 4. Log any errors if the API call fails
  //       console.error(' API Error:', error);

  //       if (error.response) {
  //         console.error('HTTP Status:', error.response.status); 
  //         console.error('Backend Error Data:', error.response.data);
  //       } else {
  //         console.error('Network/CORS Error:', error.message);
  //       }
  //     });
  // }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.csvFile = file; // CRITICAL: Actually save the file!
      this.selectedFileName = file.name;

      // Tell the Angular Form that the requirement is met so the error message goes away
      this.campaignForm.patchValue({ contactList: file.name });
      this.campaignForm.get('contactList')?.markAsTouched();

    } else {
      this.csvFile = null;
      this.selectedFileName = '';

      // If the user cancels the upload, tell the form it's empty again
      this.campaignForm.patchValue({ contactList: null });
    }
  }

  // Method to switch channels when a button is clicked
  setChannel(channel: 'email' | 'whatsapp') {
    this.activeChannel = channel;
  }

  async loadTemplates(channel: 'email' | 'whatsapp' | 'sms'): Promise<void> {
    this.isLoading = true;

    const responseData = await this.campaignService
      .campaignlist(channel)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error(' API CRASHED:', error);
        return error;
      });

    // Stop loading state
    this.isLoading = false;

    // Check response and show SnackBars
    if (Array.isArray(responseData)) {
      this.templates = responseData.map(t => ({
        value: String(t.id),
        viewValue: t.name.trim()
      }));
    } else {
      const code = Number(responseData.code || responseData.status);

      if (code === HttpStatusCode.BadRequest) {
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again.");
      } else if (code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      } else {
        this.snackBarService.openFailureSnackBar("Unable to load templates.");
      }
    }
  }

  async onCreateCampaign() {


    // 1. Initial Validations
    if (this.campaignForm.invalid) {
      // console.log(' STOPPED: The Angular Form is invalid!');
      // console.log('Form Errors:', this.campaignForm.errors);
      // console.log('Campaign Name Status:', this.campaignForm.get('campaignName')?.status);

      this.campaignForm.markAllAsTouched();
      // Added an alert so you actually know it failed here!
      // alert('Form is invalid! Please check the Campaign Name.'); 
      // return; 
    }

    // console.log('2. Form is valid. Checking files and channels...');

    if (!this.selectedChannel || !this.csvFile) {

      this.snackBarService.openFailureSnackBar("Please select a channel, template, and upload a CSV.");
      return;
    }
    const selectedId = this.campaignForm.get('template')?.value;
    const matchingTemplate = this.templates.find(t => t.value === selectedId);

    // 2. Start the loading state 
    this.isLoading = true;

    // 3. Convert CSV and build the Model
    const base64CsvData = await this.convertToBase64(this.csvFile);
    // console.log('4. CSV Converted. Building payload...');

    let newCampaign = new CampaignPayload();
    newCampaign.setName(this.campaignForm.get('campaignName')?.value);
    // newCampaign.setChannel(this.selectedChannel === 'email' ? 'email' : 'whatsapp');
    newCampaign.setChannel(this.selectedChannel);
    newCampaign.setSubject(matchingTemplate ? matchingTemplate.viewValue : 'Default Subject');
    // Wrapping it in parseInt to convert the string to an integer!
    // 👇 Added .toLowerCase() to make it bulletproof
    newCampaign.setTemplateId(
      this.selectedChannel?.toLowerCase() === 'whatsapp'
        ? 2
        : Number(this.campaignForm.get('template')?.value || 0)
    );
    // newCampaign.setTemplateId(Number(selectedId));
    newCampaign.setMessageTemplate('html');
    newCampaign.setStatus("draft");
    newCampaign.setCreatedBy(parseInt(this.sessionStorageService.getCurrentUserId(), 10));
    newCampaign.setCsvAttachments([{
      fileName: this.csvFile.name,
      data: base64CsvData,
      contentType: this.csvFile.type || "text/csv"
    }]);


    // 4. Send to Service and parse response
    const responseData = await this.campaignService
      .createCampaign(newCampaign)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        console.error(' API CRASHED:', error);
        return error;
      });

    // console.log('BACKEND RESPONSE RECEIVED:', responseData);

    // 5. Stop loading state
    this.isLoading = false;

    // 6. Check Status Codes and show SnackBars
    if (responseData.status === HttpStatusCode.Ok || responseData.status === 200 || responseData.status === 201) {
      this.snackBarService.openSuccessSnackBar("Campaign submitted successfully!");
      this.next.emit(true);
      this.router.navigate(['/campaign']);
    } else {
      // console.log(' API RETURNED A FAILURE STATUS CODE');
      if (responseData.code === HttpStatusCode.BadRequest || responseData.status === 400) {
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again.");
      }
      if (responseData.code === HttpStatusCode.Unauthorized || responseData.status === 401) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }
  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const result = reader.result as string;

        // Remove metadata prefix
        const base64 = result.split(',')[1];

        resolve(base64);
      };

      reader.onerror = error => reject(error);
    });
  }

  onCancel(): void {
    this.router.navigate(['/campaign']);
  }
}
